import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const PriorityBadge = ({ level }) => {
  return (
    <Badge level={level}>
      <Dot />
      {level.charAt(0).toUpperCase() + level.slice(1)}
    </Badge>
  );
};

PriorityBadge.propTypes = {
  level: PropTypes.oneOf(['high', 'medium', 'low']).isRequired,
};

export default PriorityBadge;

const colorStyles = {
  high: {
    bg: '#ffe5e5',
    color: '#d32f2f',
  },
  highest: {
    bg: '#ffe5e5',
    color: '#d32f2f',
  },
  medium: {
    bg: '#fff4e5',
    color: '#f57c00',
  },
  low: {
    bg: '#e8f5e9',
    color: '#388e3c',
  },
};

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  height: 24px;
  ${({ level }) => css`
    background-color: ${colorStyles[level].bg};
    color: ${colorStyles[level].color};
    border: 1px solid ${colorStyles[level].color}33;
  `}
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
`;
